const initialState = () => ({
  isOpened: false,
  loading: false,
  error: null,
  data: {}
});

const ACTION_KEY = 'CHECKING_CHECKOUT_MODAL';

const reducer = (state = initialState(), reduxAction) => {
  switch (reduxAction.type) {
    case `${ACTION_KEY}_OPEN`: {
      return {
        ...state,
        isOpened: true
      };
    }

    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
